/*
 * ConclusionPage Messages
 *
 * This contains all the text for the ConclusionPage container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.ConclusionPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Time slot overview",
  },
  fromTime: {
    id: `${scope}.fromTime`,
    defaultMessage: "Start time",
  },
  toTime: {
    id: `${scope}.toTime`,
    defaultMessage: "End time",
  },
  planAnother: {
    id: `${scope}.planAnother`,
    defaultMessage: "Book another time slot",
  },
});
